<script setup>
import {componentSizes} from '@/constants/components.js'

//Props
defineProps({
  size: {
    type: String,
    default: componentSizes.M,
    validator(value) {
      return Object.values(componentSizes).includes(value)
    },
  },
  tag: {
    type: String,
    default: 'div',
  },
  text: {
    type: String,
    default: '',
  },
  hasMargin: {
    type: Boolean,
    default: true,
  },
})
</script>

<template>
  <component
    :is="tag"
    :class="{
      [$style.heading]: true,
      [$style.hasMargin]: hasMargin,
      [$style[size]]: !!size,
    }"
    hide-empty
  >
    <slot>{{ text }}</slot>
  </component>
</template>

<style module>
.heading {
  margin: 0;
  line-height: var(--line-height-headings);
  &.hasMargin {
    margin-top: 0.25rem;
    margin-bottom: 0.5rem;
  }
  &.xs {
    font-size: var(--font-size-heading-xs);
    font-weight: var(--font-weight-bold);
  }
  &.s {
    font-size: var(--font-size-heading-s);
    font-weight: var(--font-weight-bold);
  }
  &.m {
    font-size: var(--font-size-heading-m);
    font-weight: var(--font-weight-bold);
  }
  &.l {
    font-size: var(--font-size-heading-l);
    font-weight: var(--font-weight-normal);
  }
  &.xl {
    font-size: var(--font-size-heading-xl);
    font-weight: var(--font-weight-normal);
  }
}
</style>
